var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adItem && _vm.adItem.content)?_c('div',[_c('iframe',{staticClass:"ad-design",attrs:{"src":_vm.adItem.content,"frameborder":"0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }